import type { ButtonHTMLAttributes } from 'react';
import { classNames } from '../../lib/format.js';

type Variant = 'primary' | 'ghost' | 'danger';

export function Button({
  variant = 'ghost',
  className,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant }) {
  const base =
    'inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition disabled:opacity-50 disabled:cursor-not-allowed';
  const styles: Record<Variant, string> = {
    primary: 'bg-[#3b82f6] text-white hover:bg-[#2f6fd4]',
    ghost:
      'border border-[var(--color-border)] bg-[var(--color-panel-2)] text-[var(--color-text)] hover:bg-[var(--color-border)]',
    danger: 'bg-[var(--color-sev-critical)] text-white hover:opacity-90',
  };
  return <button className={classNames(base, styles[variant], className)} {...props} />;
}
